export default __webpack_public_path__ + "static/NBInternationalPro-Regular-7b4434e128ae08b40c91d34af075ca65.eot";